export const margin = '0 0 20px 0'